export default "__VITE_ASSET__Ch$56a9L__"